<template>
  <div>
    <h2 class="font-weight-bold mb-4">Identification</h2>
    <div class="identification">
      <b-row>
        <b-col cols="12" sm="12" md="8" lg="8">
          <p>This is a popular way for providing identification details</p>
          <p class="font-weight-bold">Just follow these three easy steps:</p>
          <p>1. Prepare your device’s camera</p>
          <p>2. Prepare the document you registered</p>
          <p>3. Take a picture</p>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <img class="avatar" src="@/assets/images/sample-avatar.jpg" alt />
        </b-col>
      </b-row>
      <p
        class="mt-4"
      >Take a photo of your face. Please don't bend your head and look straight to camera</p>
      <button class="verification">Start Photo Identification</button>
      <p  class="maps"><b-link>You can go throw the process online or go to branch</b-link></p>
      <div class="d-flex justify-content-end mb-4 next">
        <!-- <button @click="this.$router.push({path: 'id'})" type="submit">Next Step</button> -->
        <b-link to="/registration/step-6/id">Next Step</b-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.identification {
  .avatar {
    width: 100%;
    border: 1px solid rgba(0,0,0,.05);
    display: block;
    max-width: 230px;
    margin: auto;
  }
  .verification {
    width: 100%;
    height: 50px;
    border: 0;
    color: #fff;
    background: $base-blue-nav;
    border-radius: 4px;
    max-width: 420px;
    display: block;
    margin: auto;
  }
  .maps {
      text-align: center;
      margin-top: 30px;
  }
}
</style>